import { FC } from 'react';
import { SxProps, Theme } from '@mui/material';
import { ModalBox, StyledCloseIcon, StyledModal } from './styles';

interface CustomModalProps {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  /**
   * Custom system styles to apply to the modal box container.
   */
  boxSx?: SxProps<Theme>;
}

const CustomModal: FC<CustomModalProps> = ({ open, handleClose, children, boxSx }) => {
  return (
    <StyledModal open={open} onClose={handleClose}>
      <ModalBox sx={boxSx}>
        <StyledCloseIcon onClick={handleClose} />
        {children}
      </ModalBox>
    </StyledModal>
  );
};

export default CustomModal;
